import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TurnMeUp from '../common/TurnMeUp.js';
import WidgetService from '../../services/widgetService.js';
import ShareService from '../../services/shareService';

class VideoItem extends Component {
    constructor(props, context) {
        super(props, context);
        this.setRef = this.setRef.bind(this);
        this.getTweetUrl = this.getTweetUrl.bind(this);
        this.getShareUrl = this.getShareUrl.bind(this);
        this.getEmailUrl = this.getEmailUrl.bind(this);
        this.playVideo = this.playVideo.bind(this);
    }
    componentDidMount() {
        WidgetService.initialiseMagnific($(this.videoAnchor));
    }

    playVideo(event) {
        //log the video play    
        this.props.actions.playVideo(this.props.video.ID);
    }    

    setRef(anchor) {
        this.videoAnchor = anchor;
    }

    getTweetUrl() {
        return ShareService.getTwitterShareUrl(this.props.match.url, `Check out this great video - '${this.props.video.Name}' by ${this.props.video.RoleDisplayName}`);
    }

    getShareUrl() {
        return ShareService.getFacebookShareUrl(this.props.match.url);
    }

    getEmailUrl() {
        const body = `${ShareService.getAbsoluteUrl(this.props.match.url)}%0A%0AShared from LoudUp`;
        const subject = `Check out this great video - '${this.props.video.Name}' by ${this.props.video.RoleDisplayName}`;
        return ShareService.getEmailShareUrl(subject, body);
    }

    render() {        
        let video = this.props.video;
        return (
            <div className="videolink" title={video.Description}>
                <a href={video.Url} className="magnific" onClick={this.playVideo} title={video.Description} ref={this.setRef}>
                    <div className="imgbox" style={{paddingBottom: '5px'}}>
                        <span className="btn-playlarge">
                            <span className="outcircle transition2" />
                            <svg className="icon icn-play transition">
                                <use xlinkHref="#icn-play" />
                            </svg>
                        </span>
                        <img src={video.ImageUrl} />
                    </div>
                    {
                        this.props.showVideoName ? <h2 style={{color: '#333'}}>{video.Name}</h2> : null
                    }
                </a>              
                {
                    this.props.showArtistName ? 
                        <p className="by">
                            By: <Link to={`/${video.RoleUsername}`} className="transition link">{video.RoleDisplayName}</Link>
                        </p> 
                        : null
                }            
                <span>
                    <TurnMeUp id={video.ID} rating={video.Rating} roleID={this.props.roleID} isMusic={false} />
                </span>                                     
                {
                    this.props.showShareButton ?
                        <div className="dropdown dropdown-share">
                            <button id="btn-share" className="btn btn-primary btn-share transition" role="button" data-toggle="dropdown">
                                <svg className="icon icn-share">
                                    <use xlinkHref="#icn-share" />
                                </svg>
                                SHARE
                            </button>
                            <ul id="menu3" className="dropdown-menu share" role="menu" aria-labelledby="drop6">
                                <li><a href={this.getTweetUrl()} className="first transition" target="_blank">
                                    <img src={require('../../images/icon-tweet.png')} width="59" height="20" alt="Tweet" />TWEET ME</a>
                                </li>
                                <li><a href={this.getShareUrl()} className="transition" target="_blank">
                                    <img src={require('../../images/icon-share.png')} width="57" height="18" alt="Share" />SHARE ME</a></li>
                                <li><a href={this.getEmailUrl()} className="transition">
                                    <img src={require('../../images/icon-email.png')} width="59" height="20" alt="Share" />EMAIL ME</a></li>
                            </ul>
                        </div>
                    :
                    null
                }        
                
            </div>
        );
    }
}

VideoItem.propTypes = {
    video: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    showVideoName: PropTypes.bool,
    showArtistName: PropTypes.bool,
    showShareButton: PropTypes.bool,
    roleID: PropTypes.number,
    match: PropTypes.object
};

export default VideoItem;